module.exports = __webpack_public_path__ + "static/img/hypnose-03.8428d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-03.png
// module id = 97
// module chunks = 0